import { colors } from './colors';

export const typography = {
  // This font size is what determines the rem to px ratio. If this font size changes, the px values next to each rem will also change.
  fontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  fontFamily: 'Lato, sans-serif',
  h1: {
    fontFamily: 'Poppins, sans-serif',
    color: colors.text.heading,
    fontWeight: 500,
    fontSize: '2.5rem', // 40px
    lineHeight: '3rem', // 48px
    letterSpacing: '-0.5px',
  },
  h2: {
    fontFamily: 'Poppins, sans-serif',
    color: colors.text.heading,
    fontWeight: 500,
    fontSize: '2rem', // 32px
    lineHeight: '2.5rem', // 40px
    letterSpacing: '-0.5px',
    transform: 'translateY(4px)',
  },
  h3: {
    fontFamily: 'Poppins, sans-serif',
    color: colors.text.heading,
    fontWeight: 500,
    fontSize: '1.5rem', // 24px
    lineHeight: '2rem', // 32px
    letterSpacing: '-0.5px',
    transform: 'translateY(3px)',
  },
  h4: {
    fontFamily: 'Poppins, sans-serif',
    color: colors.text.subheading,
    fontWeight: 500,
    fontSize: '1.125rem', // 18px
    lineHeight: '1.5rem',
    transform: 'translateY(2px)',
  },
  h5: {
    fontFamily: 'Poppins, sans-serif',
    color: colors.text.subheading,
    fontWeight: 500,
    fontSize: '1rem', // 16px
    lineHeight: '1.25rem',
    transform: 'translateY(1px)',
  },
  h6: {
    fontFamily: 'Poppins, sans-serif',
    color: colors.text.subheading,
    fontWeight: 500,
    fontSize: '.875rem', // 14px
    lineHeight: '1rem', // 16px
  },
  body1: {
    color: colors.text.body,
    fontSize: '1rem', // 16px
    lineHeight: '1.5rem', // 24px
    letterSpacing: '.15px',
  },
  body1Dark: {
    color: colors.text.bodyDark,
    fontSize: '1rem', // 16px
    lineHeight: '1.5rem',
    letterSpacing: '.15px',
  },
  body2: {
    color: colors.text.body,
    fontSize: '.875rem', // 14px
    lineHeight: '1.25rem', // 20px
    letterSpacing: '.17px',
  },
  body2Dark: {
    color: colors.text.bodyDark,
    fontSize: '.875rem', // 14px
    lineHeight: '1.25rem', // 20px
    letterSpacing: '.17px',
  },
  body3: {
    color: colors.text.body,
    fontSize: '.75rem', // 12px
    lineHeight: '1.125rem', // 18px
  },
  body3Dark: {
    color: colors.text.bodyDark,
    fontSize: '.75rem', // 12px
    lineHeight: '1.125rem', // 18px
  },
  subtitle1: {
    color: colors.text.body,
    fontWeight: 600,
    fontSize: '1.25rem', // 20px
    lineHeight: '1.5rem', // 24px
  },
  subtitle1Dark: {
    color: colors.text.bodyDark,
    fontWeight: 600,
    fontSize: '1.25rem', // 20px
    lineHeight: '1.5rem', // 24px
  },
  subtitle2: {
    color: colors.text.body,
    fontWeight: 600,
    fontSize: '1', // 16px,
    lineHeight: '1.25rem', // 20px
  },
  subtitle2Dark: {
    color: colors.text.bodyDark,
    fontWeight: 600,
    fontSize: '1', // 16px,
    lineHeight: '1.25rem', // 20px
  },
};
